import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { SessionWithUsers } from "../../../types/index";
import { useAdministrateSessionMutation } from "src/features/sessions/session.service";
import { Button } from "src/components/Form/button";
import { showToast } from "src/store/toast.store";
import { useAppDispatch } from "src/store";
import { UserTransaction } from "src/features/users-transactions/types/user-transaction.entity";

type Props = {
  session: SessionWithUsers["session"];
  transactions: UserTransaction[];
};

export const SessionAdminAlert: React.FC<Props> = ({ session, transactions }) => {
  const [administrateSession] = useAdministrateSessionMutation();
  const dispatch = useAppDispatch();

  const handleAdministrate = async () => {
    try {
      await administrateSession({
        sessionId: session.id,
        type: session.type,
      }).unwrap();

      dispatch(showToast({ message: `Successfully administrate session` }));
    } catch (error) {
      console.log(error);
      dispatch(showToast({ message: error as string, type: "error" }));
    }
  };

  const checkSessionIsNotAdministrated = () => {
    if (!["ACTIVE", "STANDBY"].includes(session.state)) {
      return false;
    }

    const hasUnfinalizedTransaction =
      session.type === "BOOKING" && transactions.some((txn) => txn.status !== "FINALIZED");

    if (!hasUnfinalizedTransaction && session.type === "BOOKING") {
      return false;
    }

    if (session.type !== "BOOKING" && transactions.length) return false;

    const baseTime = session.startTime.toDate().getTime() + 60 * 60 * 1000;

    const extensionEnd =
      session.extensions?.reduce((total, ext) => total + ext.additionalMinutes * 60 * 1000, baseTime) ?? baseTime;

    return Date.now() > extensionEnd;
  };

  if (checkSessionIsNotAdministrated()) {
    return (
      <div className="mb-4 flex items-center gap-3 bg-yellow-100 border border-yellow-400 rounded p-3">
        <FiAlertTriangle className="text-yellow-600 w-6 h-6" />
        <span className="text-yellow-800 font-medium">
          Session requires administration! It has not been administrated within 60 minutes after start (including
          extensions).
        </span>
        <Button color="primary" onClick={handleAdministrate}>
          Administrate Now
        </Button>
      </div>
    );
  } else return <></>;
};
